import {
  ActivityIndicator,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useState } from "react";
import { addToFavourite, deleteFavourite } from "appRedux/reducers/cartSlice";
import { useDispatch, useSelector } from "react-redux";

import { Colors } from "colors";
import ImageView from "../../src/image";
import { Images } from "assets";
import { logEvent } from "firebase/analytics";
import { analytics } from "utils/firebaseConfig";
import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS } from "utils/Constants";
import { trackV2 } from "utils/Segment";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";

const FavComp = ({ productId, deleteFav = () => {}, productName = "" }) => {
  const [loading, setLoading] = useState(false);

  const userId = useSelector((state) => state.AuthReducer.userId);
  const profileData = useSelector((state) => state.ProfileReducer.profileData);
  const favouriteProductIds =
    useSelector((state) => state.ProductSlice.favouriteProductIds) || [];
  const _loginModalRef = useSelector(
    (state) => state.UtilsReducer._loginModalRef
  );

  const dispatch = useDispatch();

  return (
    <>
      <TouchableOpacity
        onPress={async () => {
          const data = {
            userId,
            productId: productId,
          };
          if (!userId || (profileData && profileData?.isGuest)) {
            _loginModalRef?.current?.show();
            return;
          }
          setLoading(true);
          if (!favouriteProductIds.includes(productId)) {
            dispatch(addToFavourite(data))
              .then((res) => {
                setLoading(false);
                if ([200].includes(res?.payload?.data?.data?.statusCode)) {
                  const eventData = {
                    product_id: productId,
                    product_name: productName,
                  };
                  trackV2(ANALYTICS_EVENT_NAMES.ADD_TO_FAVOURITE, eventData);
                } else {
                  alert("Error");
                }
              })
              .catch((err) => {
                setLoading(false);
                alert("Error");
              });
          } else {
            dispatch(deleteFavourite(data))
              .then((res) => {
                setLoading(false);
                if ([200].includes(res?.payload?.status)) {
                  deleteFav && deleteFav();
                } else {
                  alert("Error");
                }
              })
              .catch((err) => {
                setLoading(false);
                alert("Error");
              });
          }
        }}
        style={{
          backgroundColor: Colors.white,
          borderRadius: 40,
          position: "absolute",
          right: 40,
          top: 20,
          padding: 8,
        }}
      >
        {loading && <ActivityIndicator size="small" color={Colors.black} />}
        {!loading && (
          <ImageView
            source={
              favouriteProductIds.includes(productId)
                ? Images.selectedFavourite
                : Images.favourite
            }
            style={{ width: 16, height: 16 }}
          />
        )}
      </TouchableOpacity>
    </>
  );
};

export default FavComp;
